module.exports = __webpack_public_path__ + "img/homeBanner.4b465695.png";